import { takeLatest, call, put } from "redux-saga/effects";
import {
  GET_JOB_FEEDBACK_REQUEST,

} from "../../actionTypes";

import {
  getJobFeedbackSuccess,
  getJobFeedbackFailure,
} from "./actions";
import AxiosInstance from "../../../services/AxiosInstance";
// Worker saga
function* fetchJobFeedbacksaction(action) {
  try {
    const response = yield call(() =>
      AxiosInstance().post("/recruiter/get_job_feedback", action.payload)
    );
    if (response.data.status) {
      yield put(getJobFeedbackSuccess(response.data));
    } else {
      getJobFeedbackFailure(response.data);
    }
  } catch (error) {
    yield put(
      getJobFeedbackFailure({ status: false, message: error.message })
    );
  }
}

// Watcher saga
function* getJobFeedbackSaga() {
  yield takeLatest(GET_JOB_FEEDBACK_REQUEST, fetchJobFeedbacksaction);
}
export default getJobFeedbackSaga;
